import { submitTechnicianServiceDone } from "../components/api";

const DB_NAME = "camp_calculator_db";
const DB_VERSION = 1;

export function openDB() {
  return new Promise((resolve, reject) => {
    console.log("📂 Opening IndexedDB:", DB_NAME);

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      console.log("⬆️ IndexedDB upgrade triggered");

      if (!db.objectStoreNames.contains("vitals")) {
        console.log("🩺 Creating object store: vitals");
        const store = db.createObjectStore("vitals", {
          keyPath: "id",
          autoIncrement: true
        });
        store.createIndex("synced", "synced", { unique: false });
      }

      if (!db.objectStoreNames.contains("audiometry")) {
        console.log("🎧 Creating object store: audiometry");
        const store = db.createObjectStore("audiometry", {
          keyPath: "id",
          autoIncrement: true
        });
        store.createIndex("synced", "synced", { unique: false });
      }
      // 🆕 OPTOMETRY STORE
      if (!db.objectStoreNames.contains("optometry")) {
        console.log("👓 Creating object store: optometry");
        const store = db.createObjectStore("optometry", {
          keyPath: "id",
          autoIncrement: true,
        });
        store.createIndex("synced", "synced", { unique: false });
      }
      //  Doctor Consultation
      if (!db.objectStoreNames.contains("doctor_consultation")) {
        console.log("🩺 Creating object store: doctor_consultation");
        const store = db.createObjectStore("doctor_consultation", {
          keyPath: "id",
          autoIncrement: true,
        });
        store.createIndex("synced", "synced", { unique: false });
      }
      // 🆕 PATIENTS STORE
      if (!db.objectStoreNames.contains("patients")) {
        console.log("🧍 Creating object store: patients");
        const store = db.createObjectStore("patients", {
          keyPath: "id",
          autoIncrement: true,
        });

        store.createIndex("synced", "synced", { unique: false });
        store.createIndex("camp", "camp", { unique: false });
        store.createIndex("package", "package", { unique: false });
      }
      // X-ray and ecg and other services can be added similarly
      if (!db.objectStoreNames.contains("service_marks")) {
        console.log("🩹 Creating object store: service_marks");

        const store = db.createObjectStore("service_marks", {
          keyPath: "id",
          autoIncrement: true
        });

        store.createIndex("synced", "synced", { unique: false });
        store.createIndex("patientId", "patientId", { unique: false });
      }
    };

    request.onsuccess = () => {
      console.log("✅ IndexedDB opened successfully");
      resolve(request.result);
    };

    request.onerror = () => {
      console.error("❌ IndexedDB open failed", request.error);
      reject(request.error);
    };
  });
}



export async function saveVitalsOffline(vitalsData) {
  console.log("💾 Saving vitals offline…", {
    patientId: vitalsData.PatientId || vitalsData.patient_id
  });

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("vitals", "readwrite");
    const store = tx.objectStore("vitals");

    store.add({
      ...vitalsData,
      synced: 0
    });

    tx.oncomplete = () => {
      console.log("✅ Vitals saved offline successfully");
      resolve();
    };

    tx.onerror = () => {
      console.error("❌ Failed to save vitals offline", tx.error);
      reject(tx.error);
    };
  });
}

export async function saveServiceMarkOffline(data) {
  console.log("💾 Saving service mark offline...", data);

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("service_marks", "readwrite");
    const store = tx.objectStore("service_marks");

    store.add({
      ...data,
      synced: 0
    });

    tx.oncomplete = () => {
      console.log("✅ Service mark saved offline");
      resolve();
    };

    tx.onerror = () => {
      console.error("❌ Failed to save service mark", tx.error);
      reject(tx.error);
    };
  });
}


export async function syncServiceMarks() {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("service_marks", "readwrite");
    const store = tx.objectStore("service_marks");
    const index = store.index("synced");

    const request = index.getAll(0);

    request.onsuccess = async () => {
      const unsynced = request.result;

      console.log("🔄 Syncing service marks:", unsynced.length);

      for (const record of unsynced) {
        try {
          await submitTechnicianServiceDone({
            patient_id: record.patientId,
            service_name: record.serviceName,
            technician_id: record.technicianId
          });

          store.delete(record.id);

          console.log("✅ Synced & removed:", record.serviceName);
        } catch (err) {
          console.error("❌ Failed syncing service mark:", err);
        }
      }

      resolve();
    };

    request.onerror = reject;
  });
}